/**
 * Iter-45.5: Vertical presets for custom buyer landing pages.
 *
 * Mirrors /app/frontend/src/pages/landing/config.js VERTICALS but scoped
 * to the fields the custom-LP editor exposes. When an admin picks a
 * vertical while creating a new LP, these values pre-fill the editor
 * (they can still edit anything). The `vertical` key is also sent to
 * the backend which uses it to stamp accident_type on incoming leads.
 */

export const VERTICAL_PRESETS = {
  auto: {
    label: "Auto Accident",
    tagline: "Car & MVA cases",
    kicker: "Auto Accident Attorneys",
    headline: "Injured in a Car Accident?",
    headlineAccent: "You may be owed compensation.",
    subheadline:
      "Medical bills, lost wages, and pain & suffering add up fast. Speak with an experienced injury attorney about your case — free, no obligation, no fee unless we win.",
    urgencyBadge: "Free 24/7 Case Review",
    ctaText: "Get My Free Case Review",
    heroImage:
      "https://images.unsplash.com/photo-1590247813693-5541d1c609fd?auto=format&fit=crop&w=1600&q=75",
    color: "#d92f2f",
  },
  truck: {
    label: "Truck / 18-Wheeler",
    tagline: "Commercial vehicle cases",
    kicker: "Truck & 18-Wheeler Accident Attorneys",
    headline: "Hit by a Semi Truck or Commercial Vehicle?",
    headlineAccent: "Serious injuries deserve serious representation.",
    subheadline:
      "Trucking companies keep teams of lawyers on retainer. You deserve one on your side. Cases involving 18-wheelers, delivery trucks, and commercial fleets often involve complex insurance layers.",
    urgencyBadge: "Serious Injury? Get Help Now",
    ctaText: "Get My Free Truck Case Review",
    heroImage:
      "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?auto=format&fit=crop&w=1600&q=75",
    color: "#0b3d91",
  },
  rideshare: {
    label: "Rideshare (Uber / Lyft)",
    tagline: "$1M policy cases",
    kicker: "Uber & Lyft Accident Attorneys",
    headline: "Hurt in an Uber or Lyft?",
    headlineAccent: "Rideshare cases are different — get the right attorney.",
    subheadline:
      "Rideshare accidents have unique insurance rules — most riders don't know Uber & Lyft carry $1M policies. Don't accept a lowball offer from an insurance adjuster without talking to an attorney.",
    urgencyBadge: "$1M Uber/Lyft Coverage",
    ctaText: "Get My Free Rideshare Review",
    heroImage:
      "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?auto=format&fit=crop&w=1600&q=75",
    color: "#111827",
  },
  motorcycle: {
    label: "Motorcycle",
    tagline: "Rider representation",
    kicker: "Motorcycle Accident Attorneys",
    headline: "Down on Your Bike Because of Someone Else?",
    headlineAccent: "Riders deserve a fair shake. Fight the bias.",
    subheadline:
      "Motorcyclists face insurance bias — you need an attorney who knows how to counter that and fight for every dollar you're entitled to for medical bills, lost wages, and pain and suffering.",
    urgencyBadge: "Riders Get Less Without a Lawyer",
    ctaText: "Get My Free Rider Case Review",
    heroImage:
      "https://images.unsplash.com/photo-1558981285-6f0c94958bb6?auto=format&fit=crop&w=1600&q=75",
    color: "#7c2d12",
  },
  other: {
    label: "Personal Injury (all-in-one)",
    tagline: "General PI, all case types",
    kicker: "Personal Injury Attorneys",
    headline: "Hurt Because of Someone Else?",
    headlineAccent: "Your free case review starts here.",
    subheadline:
      "Motor-vehicle crashes, slip and falls, medical malpractice, defective products, dog bites, nursing-home neglect, wrongful death — if someone else is responsible for your injury, you deserve to speak with an experienced attorney about what you might be entitled to.",
    urgencyBadge: "Free 24/7 Case Review",
    ctaText: "Get My Free Case Review",
    heroImage:
      "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&w=1600&q=75",
    color: "#f1b62c",
  },
};

// Ordered list for pickers.
export const VERTICAL_ORDER = ["auto", "truck", "rideshare", "motorcycle", "other"];

// Human label for a vertical key. Falls back to "Personal Injury" so pre-45.5
// rows (no vertical stored) still render sensibly in the LP list.
export function verticalLabel(key) {
  return (VERTICAL_PRESETS[key] || VERTICAL_PRESETS.other).label;
}

export function verticalColor(key) {
  return (VERTICAL_PRESETS[key] || VERTICAL_PRESETS.other).color;
}
